// src/pages/MarketplaceIntegration/MarketplaceDashboard.jsx

import React from 'react';

const MarketplaceDashboard = ({ marketplaces, onSyncMarketplace }) => {
  const handleManualSync = async (marketplaceId) => {
    // Update the marketplace status to 'syncing'
    await onSyncMarketplace(marketplaceId, { syncStatus: 'syncing' });
    
    // In a real implementation, this would trigger the actual sync process
    // For now, we'll simulate it with a timeout
    setTimeout(async () => {
      await onSyncMarketplace(marketplaceId, { 
        syncStatus: 'success',
        lastSync: new Date()
      });
    }, 2000);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'success': return '#10B981';
      case 'error': return '#EF4444';
      case 'syncing': return '#3B82F6';
      case 'idle': return '#9CA3AF';
      default: return '#9CA3AF';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'success': return 'Başarılı';
      case 'error': return 'Hata';
      case 'syncing': return 'Senkronize Ediliyor';
      case 'idle': return 'Beklemede';
      default: return 'Bilinmiyor';
    }
  };

  const getMarketplaceIcon = (name) => {
    switch (name.toLowerCase()) {
      case 'trendyol': return '🟡';
      case 'hepsiburada': return '🔵';
      case 'amazon': return '🟠';
      case 'n11': return '🔴';
      case 'etsy': return '🟢';
      default: return '🏪';
    }
  };

  return (
    <div className="marketplace-dashboard">
      <div className="dashboard-header">
        <h2>Entegrasyon Durumu</h2>
        <p>Bağlı pazaryerlerinin senkronizasyon durumunu görüntüleyin</p>
      </div>

      {marketplaces.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">🏪</div>
          <h3>Henüz bir pazaryeri bağlantısı yok</h3>
          <p>Başlamak için "Bağlantılar" sekmesinden yeni bir pazaryeri ekleyin</p>
        </div>
      ) : (
        <div className="marketplace-grid">
          {marketplaces.map(marketplace => (
            <div key={marketplace.id} className="marketplace-card">
              <div className="marketplace-header">
                <div className="marketplace-icon">
                  {getMarketplaceIcon(marketplace.name)}
                </div>
                <div className="marketplace-info">
                  <h3>{marketplace.name}</h3>
                  <p>{marketplace.storeName || 'Mağaza adı belirtilmemiş'}</p>
                </div>
                <div className="marketplace-status">
                  <span 
                    className="status-indicator"
                    style={{ backgroundColor: getStatusColor(marketplace.syncStatus) }}
                  ></span>
                  <span>{getStatusText(marketplace.syncStatus)}</span>
                </div>
              </div>
              
              <div className="marketplace-details">
                <div className="detail-item">
                  <span className="detail-label">Son Senkronizasyon:</span>
                  <span className="detail-value">
                    {marketplace.lastSync 
                      ? new Date(marketplace.lastSync.seconds * 1000).toLocaleString('tr-TR')
                      : 'Henüz senkronize edilmedi'}
                  </span>
                </div>
                
                <div className="detail-item">
                  <span className="detail-label">Durum:</span>
                  <span className="detail-value">
                    {marketplace.isActive ? 'Aktif' : 'Pasif'}
                  </span>
                </div>
                
                <div className="detail-item">
                  <span className="detail-label">API Tipi:</span>
                  <span className="detail-value">{marketplace.apiType || 'Belirtilmemiş'}</span>
                </div>
              </div>
              
              <div className="marketplace-actions">
                <button 
                  className="sync-button"
                  onClick={() => handleManualSync(marketplace.id)}
                  disabled={marketplace.syncStatus === 'syncing'}
                >
                  {marketplace.syncStatus === 'syncing' ? 'Senkronize Ediliyor...' : 'Şimdi Senkronize Et'}
                </button>
                
                <button 
                  className="toggle-button"
                  onClick={() => onSyncMarketplace(marketplace.id, { isActive: !marketplace.isActive })}
                >
                  {marketplace.isActive ? 'Devre Dışı Bırak' : 'Etkinleştir'}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MarketplaceDashboard;